// src/components/faq/PerceptualSkillDevelopmentFAQ.jsx

const perceptualSkillDevelopmentFaqItems = [
  {
    question: 'What is perceptual skill development?',
    answer:
      'Perceptual skill development is the gradual strengthening of auditory-perceptual voice evaluation skills through structured listening, active judgment, comparison, feedback, reflection, and repeated exposure to varied voice samples.',
  },
  {
    question: 'Who can use All-Voiced perceptual activities?',
    answer:
      'All-Voiced perceptual activities may be relevant to students, clinicians, educators, researchers, voice teachers, vocal coaches, performers, and other professionals working with voice. Suitability, required experience, and access conditions vary by catalog entry.',
  },
  {
    question: 'Do I need previous experience in voice evaluation?',
    answer:
      'Not necessarily. Some activities are suitable for early learners, while others are designed for people with prior experience in auditory-perceptual voice evaluation. Each catalog entry indicates its intended context, access conditions, and available support.',
  },
  {
    question: 'What kinds of listening activities are available?',
    answer:
      'Available formats may include VAS rating activities, paired comparisons or 2AFC tasks, categorization, ranking or sorting, CAPE-V and CAPE-Vr-related workflows, and other structured listening resources. The app catalog is the current source of truth for self-directed activity availability.',
  },
  {
    question: 'What is the difference between an Activity and a Live Session?',
    answer:
      'Activities are typically designed to be launched and completed without requiring a simultaneous group. Live Sessions are facilitated synchronous experiences that require a facilitator and multiple participants in a shared classroom, workshop, or online setting. Facilitators start Live Sessions from Facilitate, and participants join them from Participate.',
  },
  {
    question: 'Can I use All-Voiced independently?',
    answer:
      'Yes. Many activities can be completed independently and at the user’s own pace, depending on their access conditions. Live Sessions and some institution-specific implementations require a facilitator, a group context, or configured access.',
  },
  {
    question: 'Can educators use the activities with students?',
    answer:
      'Yes. Educators may use appropriate activities for classroom practice, guided discussion, facilitated group learning, or course support. Configured course, cohort, assessment, analytics, or educational research implementations are addressed through Institutional Programs.',
  },
  {
    question: 'Can All-Voiced support facilitated group learning?',
    answer:
      'Yes. Live Sessions support synchronous group listening with a facilitator and multiple participants. More customized modules, cohort workflows, analytics, or institution-specific implementations may be developed through Institutional Programs.',
  },
  {
    question: 'Are the activities free?',
    answer:
      'Many All-Voiced activities are currently available free of charge. Other entries may require registration, eligibility, institutional access, or payment. Specialized resources, facilitated sessions, programs, and licensed materials may use different access models. Current access conditions are shown in each catalog entry.',
  },
  {
    question: 'Do all activities include expert feedback or reference ratings?',
    answer:
      'No. Feedback and reference models vary. Some activities may include expert, consensus, reference, or other structured feedback data, while others support practice, reflection, or participation without the same feedback model.',
  },
  {
    question: 'Does completing an activity provide certification or clinical authorization?',
    answer:
      'Not by default. Most activities support practice, structured listening, or skill development. Completing an activity does not automatically establish calibration, reliability, clinical competence, certification, or diagnostic authority. Any formal certification has its own explicitly defined requirements and access conditions.',
  },
  {
    question: 'How do Perceptual Skill Development and Institutional Programs differ?',
    answer:
      'Perceptual Skill Development focuses on how individuals and groups develop auditory-perceptual expertise through available activities and facilitated Live Sessions. Institutional Programs configure these and other capabilities within courses, cohorts, assessment models, learning analytics, educational research, or broader institutional implementation.',
  },
  {
    question: 'Where can I see what is currently available?',
    answer:
      'The All-Voiced app catalog is the operational surface for discovering and launching current activities, programs, resources, datasets, certifications, services, and other available entries. Live Sessions are run through Facilitate and joined from Participate.',
  },
];

export default function PerceptualSkillDevelopmentFAQ() {
  return (
    <section
      className="service-landing-section service-landing-faq"
      aria-labelledby="perceptual-skill-development-faq-title"
    >
      <span className="services-label">
        FAQ
      </span>

      <h2 id="perceptual-skill-development-faq-title">
        Perceptual Skill Development FAQ
      </h2>

      <p>
        Common questions about using All-Voiced for structured listening,
        feedback, independent practice, and facilitated group learning.
      </p>

      <div className="service-landing-faq-list">
        {perceptualSkillDevelopmentFaqItems.map((item) => (
          <details className="service-landing-faq-item" key={item.question}>
            <summary>
              <span>{item.question}</span>
            </summary>

            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
